<template>
  <div>
    <LayoutContent>
      <SectionTitle :label="$t('label.myProfile')" />
      <v-container class="green-gradient-down d-flex flex-column align-center justify-space-between rounded-lg" v-if="currentUser">
        <div class="mx-auto my-8 text-center">
          <div class="text-center d-flex flex-row align-center justify-center my-8">
            <div class="mr-6" v-if="isSGUser" @click="isQrDialogShow = true"><VueQrcode :value="currentUser.member_id" :options="{ margin: 1, width: 60 }"></VueQrcode></div>
            <div>
              <h3 class="font-bukhari text-h4 mr-2 white--text">{{ $t('label.hello') }}!</h3>
              <span class="text-h5 font-weight-bold yellow--text text--lighten-1">{{ currentUser.full_name }}</span>
            </div>
          </div>
          <app-button :label="$t('label.shareAndRewards')" class="secondary--text px-7" @click="isReferDialogShow = true" />
        </div>
        <v-container class="white rounded-lg" v-if="currentUser">
          <v-row class="pa-4" justify="space-between">
            <v-col :class="$vuetify.breakpoint.smAndUp ? 'py-0' : 'pa-0'" :xs="12" :sm="6" :cols="12">
              <div class="border-bottom" :class="$vuetify.breakpoint.smAndUp ? 'pa-2 px-4' : 'py-2 px-4'">
                <p class="text-subtitle-1 secondary--text font-weight-bold">{{ $t('label.name') }}</p>
                <p class="text-subtitle-2 secondary--text text--lighten-1">{{ currentUser.full_name }}</p>
              </div>
            </v-col>
            <v-col :class="$vuetify.breakpoint.smAndUp ? 'py-0' : 'pa-0'" :xs="12" :sm="6" :cols="12">
              <div class="border-bottom" :class="$vuetify.breakpoint.smAndUp ? 'pa-2 px-4' : 'py-2 px-4'">
                <p class="text-subtitle-1 secondary--text font-weight-bold">{{ $t('label.memberId') }}</p>
                <p class="text-subtitle-2 secondary--text text--lighten-1">{{ currentUser.member_id }}</p>
              </div>
            </v-col>
            <v-col :class="$vuetify.breakpoint.smAndUp ? 'py-0' : 'pa-0'" :xs="12" :sm="6" :cols="12">
              <div class="border-bottom d-flex flex-row justify-space-between align-center" :class="$vuetify.breakpoint.smAndUp ? 'pa-2 px-4' : 'py-2 px-4'">
                <div>
                  <p class="text-subtitle-1 secondary--text font-weight-bold">{{ $t('label.mobileNumber') }}</p>
                  <p class="text-subtitle-2 secondary--text text--lighten-1">{{ countryCode }}{{ currentUser.mobile }}</p>
                </div>
                <v-btn link text @click.prevent="isEditMobileDialogShow = true" class="text-capitalize no-letter-spacing white" color="primary">{{ $t('label.edit') }}</v-btn>
              </div>
            </v-col>
            <v-col :class="$vuetify.breakpoint.smAndUp ? 'py-0' : 'pa-0'" :xs="12" :sm="6" :cols="12">
              <div class="border-bottom d-flex flex-row justify-space-between align-center" :class="$vuetify.breakpoint.smAndUp ? 'pa-2 px-4' : 'py-2 px-4'">
                <div>
                  <p class="text-subtitle-1 secondary--text font-weight-bold">{{ $t('label.email') }}</p>
                  <p class="text-subtitle-2 secondary--text text--lighten-1">{{ currentUser.email }}</p>
                </div>
                <v-btn link text @click.prevent="isEditEmailDialogShow = true" class="text-capitalize no-letter-spacing white" color="primary">{{ $t('label.edit') }}</v-btn>
              </div>
            </v-col>
            <v-col :class="$vuetify.breakpoint.smAndUp ? 'py-0' : 'pa-0'" :xs="12" :sm="6" :cols="12">
              <div class="border-bottom d-flex flex-row justify-space-between align-center" :class="$vuetify.breakpoint.smAndUp ? 'pa-2 px-4' : 'py-2 px-4'">
                <div>
                  <h3 class="text-subtitle-1 secondary--text font-weight-bold">{{ $t('label.dob') }}</h3>
                  <p class="text-subtitle-2 secondary--text text--lighten-1">{{ currentUser.birthday | shortDate }}</p>
                </div>
                <v-btn v-if="currentUser.birthday === null" link text @click.prevent="isEditDobDialogShow = true" class="text-capitalize no-letter-spacing white" color="primary">
                  {{ $t('label.edit') }}
                </v-btn>
              </div>
            </v-col>
            <v-col :class="$vuetify.breakpoint.smAndUp ? 'py-0' : 'pa-0'" :xs="12" :sm="6" :cols="12">
              <div class="border-bottom d-flex flex-row justify-space-between align-center" :class="$vuetify.breakpoint.smAndUp ? 'pa-2 px-4' : 'py-2 px-4'">
                <div>
                  <h3 class="text-subtitle-1 secondary--text font-weight-bold">{{ $t('label.gender') }}</h3>
                  <p class="text-subtitle-2 secondary--text text--lighten-1" v-if="currentUser.gender">{{ $t(`label.${currentUser.gender.toLowerCase()}`) }}</p>
                </div>
                <v-btn link text @click.prevent="isEditGenderDialogShow = true" class="text-capitalize no-letter-spacing white" color="primary">{{ $t('label.edit') }}</v-btn>
              </div>
            </v-col>
            <v-col :class="$vuetify.breakpoint.smAndUp ? 'py-0' : 'pa-0'" :xs="12" :sm="6" :cols="12">
              <div class="border-bottom d-flex flex-row justify-space-between align-center" :class="$vuetify.breakpoint.smAndUp ? 'pa-2 px-4' : 'py-2 px-4'">
                <h3 class="text-subtitle-1 secondary--text font-weight-bold">{{ $t('label.password') }}</h3>
                <v-btn link text @click.prevent="isEditPasswordDialogShow = true" class="text-capitalize no-letter-spacing white" color="primary">{{ $t('label.edit') }}</v-btn>
              </div>
            </v-col>
            <v-col :class="$vuetify.breakpoint.smAndUp ? 'py-0' : 'pa-0'" :xs="12" :sm="6" :cols="12">
              <div class="border-bottom d-flex flex-row justify-space-between align-center" :class="$vuetify.breakpoint.smAndUp ? 'pa-2 px-4' : 'py-2 px-4'">
                <h3 class="text-subtitle-1 secondary--text font-weight-bold">{{ $t('label.addressBook') }}</h3>
                <v-btn color="white" link text class="white" :to="{ name: $constants.ROUTE_NAME.PROFILE_ADDRESS_BOOK }" v-if="currentUser">
                  <v-icon color="green" class="white">mdi-chevron-right</v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-container>

      <v-card class="mt-15" v-if="currentUser">
        <div class="setting py-4 px-5 d-flex flex-row justify-space-between w-100">
          <p class="white--text font-weight-bold">{{ $t('label.settings') }}</p>
        </div>
        <v-card-text class="white rounded-lg">
          <v-row>
            <v-col class="border-bottom ma-4 mt-0 px-4 py-2 d-flex flex-row justify-space-between align-center">
              <div class="d-flex flex-row align-center">
                <span class="text-center"><v-icon color="primary" class="transparent" size="50">$notification</v-icon></span>
                <h3 class="text-subtitle-1 secondary--text font-weight-bold">
                  {{ $t('label.pushNotification') }}
                </h3>
              </div>
              <v-switch
                inset
                v-model="pushEnabled"
                class="white mt-0"
                light
                hide-details
                :readonly="pushPermission != 'granted'"
                :disabled="!isPushSupported"
                @click="onPushNotificationClick"
                @change="onPushNotificationChange"
              />
            </v-col>

            <!-- NON-SELECTABLE LANGUAGE OPTION -->
            <!-- <v-col class="border-bottom ma-4 mt-0 px-4 py-2 d-flex flex-column">
              <div class="d-flex flex-row align-center">
                <span class="text-center"><v-icon color="primary" class="transparent" size="50">$language</v-icon></span>
                <div>
                  <h3 class="text-subtitle-1 secondary--text font-weight-bold">{{ $t('label.language') }}</h3>
                  <p class="text-subtitle-2 secondary--text text--lighten-1">English</p>
                </div>
              </div>
            </v-col> -->

            <!-- SELECTABLE LANGUAGE OPTION -->
            <v-col class="border-bottom ma-4 mt-0 px-4 py-2 d-flex flex-row justify-space-between align-center">
              <div class="d-flex flex-row align-center">
                <span class="text-center"><v-icon color="primary" class="transparent" size="50">$language</v-icon></span>
                <div>
                  <h3 class="text-subtitle-1 secondary--text font-weight-bold">{{ $t('label.language') }}</h3>
                  <p class="text-subtitle-2 secondary--text text--lighten-1">{{ $t(`label.${currentSelectedLanguage.toLowerCase()}`) }}</p>
                </div>
              </div>
              <v-btn link text @click.prevent="isEditLanguageDialogShow = true" class="text-capitalize no-letter-spacing white" color="primary">{{ $t('label.edit') }}</v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="border-bottom ma-4 mt-0 px-4 py-2 d-flex flex-row justify-space-between align-center">
              <div class="d-flex flex-row align-center">
                <span class="text-center"><v-icon color="primary" class="transparent" size="50">$policy</v-icon></span>
                <h3 class="text-subtitle-1 secondary--text font-weight-bold">
                  {{ $t('label.privacyPolicy') }}
                </h3>
              </div>
              <v-btn color="white" link text class="white" :to="{ name: $constants.ROUTE_NAME.PRIVACY_POLICY }" v-if="currentUser">
                <v-icon color="green" class="white">mdi-chevron-right</v-icon>
              </v-btn>
            </v-col>
            <v-col class="border-bottom ma-4 mt-0 px-4 py-2 d-flex flex-row justify-space-between align-center">
              <div class="d-flex flex-row align-center">
                <span class="text-center"><v-icon color="primary" class="transparent" size="50">$tnc</v-icon></span>
                <h3 class="text-subtitle-1 secondary--text font-weight-bold">
                  {{ $t('label.termsOfUse') }}
                </h3>
              </div>
              <v-btn
                color="white"
                link
                text
                class="white"
                :to="{ name: currentUser.roles === 'Agent' ? $constants.ROUTE_NAME.AGENT_TERMS_OF_SERVICE : $constants.ROUTE_NAME.TERMS_OF_SERVICE }"
                v-if="currentUser"
              >
                <v-icon color="green" class="white">mdi-chevron-right</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- QR dialog -->
      <app-dialog v-model="isQrDialogShow" title="" v-if="currentUser">
        <VueQrcode :value="currentUser.member_id" :options="{ margin: 1, width: 200 }"></VueQrcode>
      </app-dialog>

      <!-- Refer Dialog -->
      <app-dialog v-model="isReferDialogShow" :title="$t('label.shareAndRewards')" maxWidth="650px">
        <img class="app-store-badge my-8 w-80" :src="referralContent.image" style="max-height: 300px; object-fit: contain" />
        <div class="mb-4">
          <p class="text-center text-capitalize text-body-1 primary--text text--darken-1 font-weight-bold">{{ referralContent.title1 }}</p>
          <p class="text-center text-subtitle-2 leading-none referral-desc" :class="$vuetify.breakpoint.smAndUp ? 'mx-10' : 'mx-2'">{{ referralContent.description1 }}</p>
        </div>
        <div>
          <p class="text-center text-body-1 primary--text text--darken-1 font-weight-bold">{{ referralContent.title2 }}</p>
          <p class="text-center text-subtitle-2 leading-none referral-desc" :class="$vuetify.breakpoint.smAndUp ? 'mx-10' : 'mx-2'">
            {{ referralContent.description2 }}
          </p>
        </div>
        <div class="mt-4" v-if="referralContent.title3">
          <p class="text-center text-body-1 primary--text text--darken-1 font-weight-bold">{{ referralContent.title3 }}</p>
          <p class="text-center text-subtitle-2 leading-none referral-desc" :class="$vuetify.breakpoint.smAndUp ? 'mx-10' : 'mx-2'">{{ referralContent.description3 }}</p>
        </div>
        <div class="mt-10 d-flex flex-row align-center w-100">
          <v-text-field
            v-model="referralLink"
            ref="textToCopy"
            color="#00C201"
            :class="!$vuetify.breakpoint.smAndUp && 'text-caption'"
            outlined
            rounded
            readonly
            dense
            append-icon="$copy"
            @click:append="copyText"
          ></v-text-field>
        </div>
      </app-dialog>

      <!-- Edit Mobile No. Dialog -->
      <app-dialog v-model="isEditMobileDialogShow" :title="$t('label.changeMobileNo')" maxWidth="600" @click:outside="resetMobileForm">
        <v-form v-model="isValid" @submit.prevent="editMobileNo" class="d-flex justify-center flex-column mx-auto w-100" ref="mobileForm">
          <v-card-text class="d-flex flex-column align-center w-80 mx-auto">
            <MobileNumberField v-if="isEditMobileDialogShow" v-model="mobileNumber" :rules="$rules.mobileNumberRules" :error-messages="mobileNumberErrors" :disableCountryCode="!isSGUser" />
            <v-expand-transition>
              <p class="error--text text-center text-mini" v-show="submissionErrors.smsError">{{ submissionErrors.smsError }}</p>
            </v-expand-transition>
          </v-card-text>

          <v-card-actions class="d-flex flex-column align-stretch px-4 mt-10 w-80 mx-auto">
            <v-btn color="primary" class="mx-2 mb-5 d-block rounded-pill green-gradient-right text-capitalize override-disabled-styles" :loading="loading" type="submit" :disabled="!isValid">
              {{ $t('label.save') }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </app-dialog>

      <!-- Edit Email Dialog -->
      <app-dialog v-model="isEditEmailDialogShow" :title="$t('label.changeEmail')" @click:outside="resetEmailForm">
        <v-form v-model="isValid" @submit.prevent="editEmail" class="d-flex justify-center flex-column mx-auto w-100" ref="emailForm">
          <v-card-text class="d-flex flex-column align-center w-100">
            <v-text-field
              dense
              v-model="email"
              :rules="$rules.emailRules"
              :label="$t('label.newEmail')"
              class="text-field-styling w-100"
              outlined
              rounded
              :error-messages="emailErrors"
              @input="clearSubmissionErrors"
            />
            <v-expand-transition>
              <p class="error--text text-center text-mini" v-show="submissionErrors.emailErrors">{{ submissionErrors.emailErrors }}</p>
            </v-expand-transition>
          </v-card-text>

          <v-card-actions class="d-flex flex-column align-stretch px-4 mt-10">
            <v-btn color="primary" class="mx-2 mb-5 d-block rounded-pill green-gradient-right text-capitalize override-disabled-styles" :loading="loading" type="submit" :disabled="!isValid">
              {{ $t('label.save') }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </app-dialog>

      <!-- Edit Gender Dialog -->
      <app-dialog v-model="isEditGenderDialogShow" :title="$t('label.gender')" @click:outside="resetGenderForm">
        <v-form v-model="isValid" @submit.prevent="editGender" class="d-flex justify-center flex-column mx-auto w-100" ref="genderForm">
          <v-card-text class="d-flex flex-column align-center w-100">
            <v-radio-group v-model="gender" row>
              <v-radio :label="$t('label.male')" value="1"></v-radio>
              <v-radio :label="$t('label.female')" value="2"></v-radio>
            </v-radio-group>
          </v-card-text>
          <v-card-actions class="d-flex flex-column align-stretch px-4 mt-10">
            <v-btn color="primary" class="mx-2 mb-5 d-block rounded-pill green-gradient-right text-capitalize override-disabled-styles" :loading="loading" type="submit" :disabled="!gender">
              {{ $t('label.save') }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </app-dialog>

      <!-- Edit DOB Dialog -->
      <app-dialog v-model="isEditDobDialogShow" :title="$t('label.dob')" @click:outside="resetBirthdayForm">
        <v-form v-model="isValid" @submit.prevent="editBirthday" class="d-flex justify-center flex-column mx-auto w-100" ref="birthdayForm">
          <v-card-text class="d-flex flex-column align-center w-100">
            <DOBPicker :label="$t('label.dob')" v-model="birthday" class="text-field-styling" :rules="$rules.requiredRules" />
          </v-card-text>
          <v-card-actions class="d-flex flex-column align-stretch px-4 mt-10">
            <v-btn color="primary" class="mx-2 mb-5 d-block rounded-pill green-gradient-right text-capitalize override-disabled-styles" :loading="loading" type="submit" :disabled="!birthday">
              {{ $t('label.save') }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </app-dialog>

      <!-- Push Notification Dialog -->
      <app-dialog v-model="isPushNotificationDialogShow" title="" maxWidth="600">
        <div class="text-body-1 font-weight-medium my-5 text-center">{{ pushNotificationDialogMessage }}</div>
        <app-button class="green-gradient-right override-disabled-styles px-15 mt-5" type="submit" invert gradient :label="$t('button.okay')" @click="isPushNotificationDialogShow = false" />
      </app-dialog>

      <!-- Edit Password Dialog -->
      <ChangePasswordDialog v-model="isEditPasswordDialogShow" />

      <!-- Edit Language Dialog -->
      <app-dialog v-model="isEditLanguageDialogShow" :title="$t('label.changeLanguage')" @click:outside="resetLanguageForm" maxWidth="500">
        <v-form v-model="isValid" @submit.prevent="editLanguage" class="d-flex justify-center flex-column mx-auto w-100" ref="languageForm">
          <v-card-text class="d-flex flex-column align-center w-100">
            <!-- item-text="name"  -->
            <v-select v-model="language" :rules="$rules.requiredRules" :items="languageList" :item-text="optionLabel" item-value="id" :label="$t('label.language')" rounded outlined></v-select>
          </v-card-text>
          <v-card-actions class="d-flex flex-column align-stretch px-4 mt-10">
            <v-btn color="primary" class="mx-2 mb-5 d-block rounded-pill green-gradient-right text-capitalize override-disabled-styles" :loading="loading" type="submit" :disabled="!gender">
              {{ $t('button.update') }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </app-dialog>
    </LayoutContent>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { localeHelper, uiHelper } from '@/utils'
import LayoutContent from '@/views/layouts/LayoutContent.vue'
import SectionTitle from '@/components/SectionTitle.vue'
import DOBPicker from '@/components/DOBPicker.vue'
import MobileNumberField from '@/components/fields/MobileNumberField'
import ChangePasswordDialog from '@/components/profile/ChangePasswordDialog.vue'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import { AUTH } from '@/api'
import AppDialog from '@/components/AppDialog.vue'

export default {
  components: { LayoutContent, SectionTitle, VueQrcode, MobileNumberField, ChangePasswordDialog, DOBPicker, AppDialog },
  data: () => ({
    isQrDialogShow: false,
    isReferDialogShow: false,
    isEditMobileDialogShow: false,
    isEditEmailDialogShow: false,
    isEditGenderDialogShow: false,
    isEditPasswordDialogShow: false,
    isEditDobDialogShow: false,
    isEditLanguageDialogShow: false,
    loading: false,
    email: '',
    mobileNumber: {
      country_id: '',
      mobile: ''
    },
    birthday: '',
    gender: '',
    language: '',
    isValid: false,
    submissionErrors: {
      email: '',
      mobileNumber: '',
      smsError: ''
    },
    referralLink: '',
    isPushSupported: false,
    // isPushSupported: OneSignal.isPushNotificationsSupported(),
    isPushNotificationDialogShow: false,
    pushNotificationDialogMessage: '',
    pushPermission: '',
    pushEnabled: false,
    referralContent: null
  }),
  created() {
    this.getShareAndRewardsContent().then((res) => {
      this.referralContent = res
    })
    this.getProfile().then(() => {
      this.email = this.currentUser.email
      this.gender = this.currentUser.gender === 'Female' ? '2' : '1'
      this.mobileNumber.country_id = this.currentUser.country_id
      this.mobileNumber.mobile = this.currentUser.mobile
      this.mobileNumber.phone_code = this.countryCode
      this.birthday = this.currentUser.birthday
      this.referralLink = `${window.location.origin}?referralCode=${this.currentUser.referral_code}`
      this.language = this.currentUser.language_id
      this.isPushSupported = OneSignal.isPushNotificationsSupported()
      if (this.isPushSupported) {
        OneSignal.push([
          'getNotificationPermission',
          (permission) => {
            this.pushPermission = permission

            // Push notification granted and deviceToken not found in localStorage
            if (this.pushPermission == 'granted' && !uiHelper.getLocalStorage('deviceToken')) {
              OneSignal.getUserId((userId) => {
                AUTH.registerDeviceToken(userId)
                uiHelper.setLocalStorage('deviceToken', userId)
              })
            }
            this.pushEnabled = this.currentUser.push_enabled && this.pushPermission == 'granted'
          }
        ])
      } else {
        this.pushEnabled = false
      }
    })
  },
  mounted() {
    OneSignal.on('subscriptionChange', (isSubscribed) => {
      if (isSubscribed) {
        OneSignal.getUserId((userId) => {
          AUTH.registerDeviceToken(userId)
          uiHelper.setLocalStorage('deviceToken', userId)
          this.setPushNotification(true)
          this.isPushSupported = true
          this.pushEnabled = true
        })
      }
    })

    OneSignal.on('notificationPermissionChange', (permissionChange) => {
      var currentPermission = permissionChange.to
      this.pushPermission = currentPermission
    })
  },
  computed: {
    ...mapGetters('auth', ['isSGUser']),
    ...mapState('auth', ['currentUser']),
    ...mapState('common', ['countryList', 'languageList']),
    countryCode() {
      let index = this.countryList.findIndex((f) => f.id === this.currentUser.country_id)
      return this.countryList[index].phone_code
    },
    currentSelectedLanguage() {
      let index = this.languageList.findIndex((f) => f.id === this.currentUser.language_id)
      return this.languageList[index].name
    },
    emailButtonIsDisabled() {
      return !this.email
    },
    emailErrors() {
      const errors = []
      this.submissionErrors.email && errors.push(this.submissionErrors.email)
      return errors
    },
    mobileNumberErrors() {
      const errors = []
      this.submissionErrors.mobileNumber && errors.push(this.submissionErrors.mobileNumber)
      return errors
    }
  },
  methods: {
    ...mapActions('common', ['requestOTP', 'verifyEmail']),
    ...mapActions('auth', ['getProfile', 'editProfile', 'enablePushNotification', 'getShareAndRewardsContent']),
    copyText() {
      let textToCopy = this.$refs.textToCopy.$el.querySelector('input')
      textToCopy.select()
      document.execCommand('copy'), this.$toast.success(this.$t('message.linkCopied'))
    },
    resetEmailForm() {
      this.$refs.emailForm.resetValidation()
      this.email = this.currentUser.email
    },
    resetGenderForm() {
      this.$refs.genderForm.resetValidation()
      this.gender = this.currentUser.gender === 'Female' ? '2' : '1'
    },
    resetBirthdayForm() {
      this.$refs.birthdayForm.resetValidation()
      this.birthday = this.currentUser.birthday
    },
    resetMobileForm() {
      this.$refs.mobileForm.resetValidation()
      this.mobileNumber.country_id = this.currentUser.country_id
      this.mobileNumber.mobile = this.currentUser.mobile
      this.mobileNumber.phone_code = this.countryCode
    },
    resetLanguageForm() {
      this.$refs.languageForm.resetValidation()
    },
    clearSubmissionErrors() {
      this.submissionErrors = {
        email: '',
        mobileNumber: '',
        smsError: ''
      }
    },
    async editEmail() {
      this.clearSubmissionErrors()
      this.loading = true
      try {
        await this.verifyEmail({
          email: this.email
        }).then((res) => {
          if (!res.is_valid) {
            throw { type: 'email', message: this.$t('error.emailTaken') }
          }
        })
        await this.editProfile({
          email: this.email
        })
          .then(() => {
            this.$toast.success(this.$t('message.emailUpdateSuccess'))
            this.isEditEmailDialogShow = false
            this.resetEmailForm()
          })
          .catch((error) => {
            this.$toast.error(error.message)
          })
      } catch (error) {
        this.submissionErrors[error.type] = error.message
      } finally {
        this.loading = false
      }
    },
    async editMobileNo() {
      this.clearSubmissionErrors()
      this.loading = true
      try {
        await this.editProfile(this.mobileNumber)
          .then(() => {
            this.$toast.success(this.$t('message.mobileNoUpdateSuccess'))
            this.isEditMobileDialogShow = false
            this.resetMobileForm()
          })
          .catch((error) => {
            this.$toast.error(error.message)
          })
      } catch (error) {
        this.submissionErrors[error.type] = error.message
      } finally {
        this.loading = false
      }
    },
    async editGender() {
      this.clearSubmissionErrors()
      this.loading = true
      try {
        await this.editProfile({ gender: this.gender })
          .then(() => {
            this.$toast.success(this.$t('message.genderUpdateSuccess'))
            this.isEditGenderDialogShow = false
            this.resetGenderForm()
          })
          .catch((error) => {
            this.$toast.error(error.message)
          })
      } catch (error) {
        this.$toast.error(error.message)
      } finally {
        this.loading = false
      }
    },
    async editBirthday() {
      this.clearSubmissionErrors()
      this.loading = true
      await this.editProfile({ birthday: this.birthday })
        .then(() => {
          this.$toast.success(this.$t('message.dobUpdateSuccess'))
          this.isEditDobDialogShow = false
          this.resetBirthdayForm()
        })
        .catch((error) => {
          this.$toast.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async editLanguage() {
      this.clearSubmissionErrors()
      this.loading = true
      try {
        await this.editProfile({ language_id: this.language })
          .then(() => {
            this.$toast.success(this.$t('message.languageUpdateSuccess'))
            this.isEditLanguageDialogShow = false
            this.resetLanguageForm()
          })
          .catch((error) => {
            console.log('Error', error)
          })
      } catch (error) {
        this.$toast.error(error.message)
      } finally {
        this.loading = false
      }
    },
    async setPushNotification(status) {
      await this.enablePushNotification({ enabled_push: status ? 1 : 0 })
    },
    onPushNotificationClick() {
      if (!this.isPushSupported) {
        this.pushNotificationDialogMessage = this.$t('message.pushNotificationNotSupported')
        this.isPushNotificationDialogShow = true
      } else if (this.pushPermission == 'denied') {
        this.pushNotificationDialogMessage = this.$t('message.pushPermissionDenied')
        this.isPushNotificationDialogShow = true
      } else if (this.pushPermission == 'default') {
        OneSignal.showNativePrompt()
      }
    },
    async onPushNotificationChange() {
      this.setPushNotification(this.pushEnabled)
    },
    optionLabel(props) {
      return this.$t(`label.${props.name.toLowerCase()}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.font-bukhari {
  font-family: 'BukhariScript' !important;
}

.icon-sizing {
  width: 40px;
  height: 40px;
}

.border-bottom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.w-full {
  width: 100%;
  background: yellow;
}

.setting {
  background-color: var(--v-primary-lighten1);
}

.leading-none {
  line-height: 18px;
}

.referral-desc {
  white-space: pre-wrap;
}

.edit-btn {
  padding: 0;
  min-width: none;
}
</style>
